import { useTranslation } from 'react-i18next';
import { Button, Modal, Tabs, PersonAvatar, Switch } from '@teo/components';
import { ArrowRight, ArrowDown } from '@teo/components/icons';
import { useEffect, useState, useContext } from 'react';
import CoursestModal from './CoursestModal';
import { Userwithorganisationwithidps } from '@/models';
import { AuthContext } from '@/components/Contexts/AuthContext';
import UserAddContent from './UserAddContent';
import { useNavigate } from 'react-router-dom';
import { axios } from '@/axios';
import { config } from '@/config';
import { useMediaQuery } from 'react-responsive';
import { T } from '@/components/T';
import './AddContentModal.css';

function AddContentModal({
  isOpenAddContentModal,
  setIsOpenAddContentModal,
  closeModal,
  setIsOpenAddContent,
  setActiveCourse,
  activeCourse,
  setCourseType,
  isStudent = false,
  activeLP,
  setActiveLP,
  student = {},
  team = {},
  importProgress,
  setImportProgress,
}: any) {
  const { t } = useTranslation();
  const [tab, setTab] = useState('courses');
  const [openCouresList, setOpenCouresList] = useState(false);
  const navigate = useNavigate();
  const [isHiddenModal, setIsHiddenModal] = useState(false);

  const [selectCourse, setSelectCourse] = useState<any>();

  const { auth } = useContext(AuthContext);
  const authUser = auth?.user as Userwithorganisationwithidps;

  const [membercourses, setMembercourses] = useState<any>(null);
  const [mycontent, setMycontent] = useState<any>(null);

  const [selectedContent, setSelectedContent] = useState<any>(null);
  const isMobile = useMediaQuery({
    query: '(max-width: 767px)',
  });

  useEffect(() => {
    setCourseType(tab);
  }, [tab]);

  const handeleAdd = async () => {
    if (activeLP) {
      const promises = [];
      promises.push(
        axios.post(`${config.backend}/lpfollows`, {
          lpgroupId: selectCourse,
          userId: isStudent,
        })
      );
      if (importProgress) {
        await Promise.allSettled(promises);
        await axios.post(`${config.teodoc}/api/lp/importprogress`, {
          lpgroupId: selectCourse,
          userId: isStudent,
        });
      }
      Promise.allSettled(promises).then((results) => {
        navigate(
          `/${authUser?.lang}/follow-up/${authUser?.activeOrganisationId}/learning-paths/details/${selectCourse}`
        );
      });
    } else {
      const promises = [];
      promises.push(
        axios.post(`${config.backend}/follows`, {
          courseId: selectCourse,
          userId: isStudent,
        })
      );
      Promise.allSettled(promises).then((results) => {
        navigate(
          `/${authUser?.lang}/follow-up/${authUser?.activeOrganisationId}/courses/details/${selectCourse}`
        );
      });
    }
  };

  useEffect(() => {
    if (selectCourse) {
      const selContent = membercourses?.find(
        (el: any) => el?.id == selectCourse
      );
      setSelectedContent(selContent || null);
    } else {
      setSelectedContent(null);
    }
  }, [selectCourse]);

  useEffect(() => {
    if (activeCourse) {
      const selContent = mycontent?.find((el: any) => el?.id == activeCourse);
      setSelectedContent(selContent || null);
    } else {
      setSelectedContent(null);
    }
  }, [activeCourse]);

  useEffect(() => {
    if (activeLP) {
      const selContent = mycontent?.find((el: any) => el?.id == activeLP);
      setSelectedContent(selContent || null);
    } else {
      setSelectedContent(null);
    }
  }, [activeLP]);

  const courseType = authUser?.useCourse;
  const assessmentType = authUser?.useAssessment;
  const vacancyType = authUser?.useLeervacature;
  const instructionType = authUser?.useInstruction;
  const lpType = authUser?.useLp;

  const handleCloseAddContentModal = () => {
    document.body.style.overflow = 'unset';
    setIsOpenAddContentModal(false);
    setOpenCouresList(false);
    setSelectCourse(null);
    setActiveCourse(null);
    setActiveLP(null);
  };

  useEffect(() => {
    if (!isOpenAddContentModal) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        handleCloseAddContentModal();
      }
    };

    document.addEventListener('keydown', handleKeyDown, true);

    return () => {
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [isOpenAddContentModal]);

  return (
    <div className="hidden bg-white">
      <Modal
        isOpen={isOpenAddContentModal}
        className={`add-content-modal add-content-modal--tall ${
          isHiddenModal ? 'hidden' : ''
        }`}
      >
        <Modal.Header
          onClose={() => {
            document.body.style.overflow = 'unset';
            setIsOpenAddContentModal(false);
            setOpenCouresList(false);
            setSelectCourse(null);
            setActiveCourse(null);
            setActiveLP(null);
          }}
        >
          <h2
            className="text-sm font-semibold"
            data-testid="addCategoriesHeader"
          >
            {t('pages.follow_up_teams.select_content')}
          </h2>
        </Modal.Header>

        <Modal.Body>
          <div className="flex flex-col">
            {isStudent && (
              <div
                className={`-mx-6 -mt-6 flex  items-center border-b bg-grey-01 px-6 py-4 sm:py-6 ${
                  isMobile && 'flex-col'
                }`}
              >
                <div
                  className={`flex flex-[1_0_45%] items-center ${
                    isMobile ? 'mx-auto' : 'mr-auto'
                  }`}
                >
                  <PersonAvatar
                    inline
                    id={student?.id}
                    name={student?.username}
                    imageSrc={student?.picture}
                  ></PersonAvatar>
                  <div className="flex flex-col">
                    <span className="max-w-[250px] overflow-hidden text-ellipsis text-sm font-medium">
                      {student?.username}
                    </span>
                    <span className="max-w-[250px] overflow-hidden text-ellipsis text-xs text-[#7d7d81]">
                      {student?.email}
                    </span>
                  </div>
                </div>
                {isMobile ? (
                  <div className="my-4">
                    <ArrowDown className="w-5 text-grey-06" />
                  </div>
                ) : (
                  <div className="mx-6">
                    <ArrowRight className="w-6 text-grey-06" />
                  </div>
                )}
                <div
                  className={`mr-auto flex flex-[1_0_45%] items-center  ${
                    isMobile ? 'mx-auto' : 'mr-auto'
                  }`}
                >
                  <div className="mr-3 h-10 w-14 min-w-[56px] rounded-md bg-[#1E1E2014]">
                    {selectedContent && (
                      <>
                        {activeLP ? (
                          <img
                            src={
                              selectedContent?.lpPicture ||
                              '/assets/images/LearnPath.png'
                            }
                            alt={selectedContent?.lpName}
                            className="inline h-full w-full rounded-lg object-cover sm:h-14"
                          />
                        ) : (
                          <img
                            src={
                              selectedContent?.courseImage ||
                              selectedContent?.image ||
                              '/images/courseFallback.png'
                            }
                            alt={selectedContent.name}
                            className="inline h-full w-full rounded-lg object-cover"
                          />
                        )}
                      </>
                    )}
                  </div>
                  {selectedContent ? (
                    <div className="flex flex-col">
                      <p className="text-sm font-medium">
                        {selectedContent?.courseName ||
                          selectedContent?.name ||
                          selectedContent?.lpName}
                      </p>
                      <span className="text-xs text-grey-06">
                        {activeLP
                          ? t(`courseTypes.learning-path`)
                          : t(
                              `courseTypes.${
                                selectedContent?.courseType ||
                                selectedContent?.publicationCourseType
                              }`
                            )}
                      </span>
                    </div>
                  ) : (
                    <p className="text-sm text-grey-06">
                      {t('pages.follow_up_teams.content_below')}
                    </p>
                  )}
                </div>
              </div>
            )}
            {!openCouresList ? (
              <>
                <div className="mb-3 mt-3 flex flex-col sm:mb-5 sm:flex-row">
                  <div>
                    <Tabs
                      activeName={tab}
                      onChange={(tab) => {
                        setTab(tab);
                        setActiveCourse(null);
                        setActiveLP(null);
                      }}
                    >
                      <div className="flex flex-col gap-3 sm:flex-row">
                        <div className="flex flex-row gap-3">
                          <>
                            {courseType && (
                              <Tabs.TabButton name="courses">
                                <p className="text-sm font-medium sm:text-base">
                                  {t('pages.follow_up_add_modal.courses')}
                                </p>
                              </Tabs.TabButton>
                            )}
                            {assessmentType && (
                              <Tabs.TabButton name="assessments">
                                <p className="text-sm font-medium sm:text-base">
                                  {t('pages.follow_up_add_modal.assessments')}
                                </p>
                              </Tabs.TabButton>
                            )}
                            {lpType && (
                              <Tabs.TabButton name="learning-paths">
                                <p className="text-base font-medium">
                                  {t('courseTypes.learning-paths')}
                                </p>
                              </Tabs.TabButton>
                            )}
                          </>
                        </div>
                        <div className="flex flex-row gap-3">
                          <>
                            {vacancyType && (
                              <Tabs.TabButton name="vacancies">
                                <p className="text-sm font-medium sm:text-base">
                                  {t('pages.follow_up_add_modal.vacancies')}
                                </p>
                              </Tabs.TabButton>
                            )}
                            {instructionType && (
                              <Tabs.TabButton name="instructions">
                                <p className="text-sm font-medium sm:text-base">
                                  {t('pages.follow_up_add_modal.instructions')}
                                </p>
                              </Tabs.TabButton>
                            )}
                          </>
                        </div>
                      </div>
                    </Tabs>
                  </div>
                </div>
                {tab === 'courses' && (
                  <div>
                    <CoursestModal
                      courseType="course"
                      selected={activeCourse}
                      setSelected={setActiveCourse}
                      setMycontent={setMycontent}
                    />
                  </div>
                )}
                {tab === 'learning-paths' && (
                  <div>
                    <CoursestModal
                      courseType="learning-path"
                      selected={activeLP}
                      setSelected={setActiveLP}
                      importProgress={importProgress}
                      setMycontent={setMycontent}
                      tableMaxHeightClass="max-h-[20vh] sm:max-h-[27vh]"
                    />
                    <div className="mt-3 flex flex-row items-center gap-4 rounded-lg border border-grey-02 p-4">
                      <div data-testid="importProgress">
                        <Switch
                          checked={importProgress}
                          onChange={(isCheck) => setImportProgress?.(isCheck)}
                        />
                      </div>
                      <div>
                        <h4 className="pb-2 font-normal">
                          {t('pages.follow_up_add_modal.import_progress_title')}
                        </h4>
                        <p className="text-xs text-grey-05">
                          {t(
                            'pages.follow_up_add_modal.import_progress_description'
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                {tab === 'assessments' && (
                  <div>
                    <CoursestModal
                      courseType="assessment"
                      selected={activeCourse}
                      setSelected={setActiveCourse}
                      setMycontent={setMycontent}
                    />
                  </div>
                )}
                {tab === 'vacancies' && (
                  <div>
                    <CoursestModal
                      courseType="leervacature"
                      selected={activeCourse}
                      setSelected={setActiveCourse}
                      setMycontent={setMycontent}
                    />
                  </div>
                )}
                {tab === 'instructions' && (
                  <div>
                    <CoursestModal
                      courseType="instruction"
                      selected={activeCourse}
                      setSelected={setActiveCourse}
                      setMycontent={setMycontent}
                    />
                  </div>
                )}
              </>
            ) : (
              <div className="-ml-6 -mr-6 flex flex-col sm:flex-row">
                <UserAddContent
                  activeCourse={activeCourse}
                  tab={tab}
                  importProgress={importProgress}
                  setOpenCouresList={setOpenCouresList}
                  setActiveCourse={setActiveCourse}
                  setSelectCourse={setSelectCourse}
                  selectCourse={selectCourse}
                  setIsOpenAddContent={setIsOpenAddContent}
                  closeModal={closeModal}
                  setIsHiddenModal={setIsHiddenModal}
                  setActiveLP={setActiveLP}
                  activeLP={activeLP}
                  setMembercourses={setMembercourses}
                  membercourses={membercourses}
                />
              </div>
            )}
          </div>
        </Modal.Body>
        <div className="relative z-10">
          <Modal.Footer
            cancelButtonLabel={t('button.cancel')}
            onCancel={() => {
              document.body.style.overflow = 'unset';
              setIsOpenAddContentModal(false);
              setOpenCouresList(false);
              setSelectCourse(null);
              setActiveCourse(null);
              setActiveLP(null);
            }}
          >
            <div data-testid="addCategoriesFooter">
              {openCouresList && (
                <>
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => {
                      setOpenCouresList(false);
                      setIsOpenAddContent(true);
                      setSelectCourse(null);
                      closeModal();
                    }}
                    className="ml-4"
                  >
                    {isMobile
                      ? t('button.create')
                      : t('pages.follow_up_teams.new_edition')}
                  </Button>
                  <Button
                    type="button"
                    onClick={() => {
                      document.body.style.overflow = 'unset';
                      handeleAdd();
                    }}
                    className="ml-4"
                    disabled={!selectCourse ? true : false}
                  >
                    {isMobile
                      ? t('button.add_btn')
                      : t('pages.follow_up_teams.add_edition')}
                  </Button>
                </>
              )}
              {!openCouresList && (
                <Button
                  type="button"
                  onClick={() => {
                    if (isStudent && tab !== 'instructions') {
                      setActiveCourse(activeCourse);
                      setActiveLP(activeLP);
                      setIsHiddenModal(true);
                      setOpenCouresList(true);
                    } else {
                      setActiveCourse(activeCourse);
                      setActiveLP(activeLP);
                      setIsHiddenModal(false);
                      setIsOpenAddContent(true);
                      closeModal();
                    }
                  }}
                  disabled={!activeCourse && !activeLP ? true : false}
                >
                  {t('button.next')}
                </Button>
              )}
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
}

export default AddContentModal;
